import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import AddIcon from "@material-ui/icons/Add";
import ToastModal from "views/components/ToastModal";
const SumInsuredCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [disabledButton, setDisabledButton] = useState(true);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [sumInsured, setSumInsured] = useState("");
  const [minAge, setMinAge] = useState("");
  const [lastIndex, setLastIndex] = useState(0);
  const [groupDetails, setGroupDetails] = useState([
    {
      minAge: "",
      maxAge: "",
      sumInsured: "",
    },
  ]);

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.SUMINSURED_FIND_ALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if (result?.data?.length > 0) {
        setGroupDetails(result?.data);
        setLastIndex(result?.data?.length - 1);
      }
    }
  };
  const saveInformation = async () => {
    if (!isAnyFieldBlank(groupDetails)) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.SUMINSURED_CREATE,
        method: "POST",
        authToken: authToken,
        data: groupDetails,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return "ERROR";
      } else {
        return "SUCCESS";
      }
    } else {
      toastUpdate("Error", "Please filled all fields", true);
    }
  };
  const handleSumInsuredSubmit = async (event) => {
    toastUpdate("", "", false);
    let status = "";
    status = await saveInformation();
    if (status === "SUCCESS") {
      const msg = params.id
        ? "SumInsured updated successfully!"
        : "SumInsured created successfully!";
      toastUpdate("Success", msg, true);
      setRedirectURL(`/coreservice/SumInsured`);
    }
  };
  const handleCancel = () => {
    navigate("/coreservice/SumInsured");
  };
  const [minAgeError, setMinAgeError] = useState(false);
  const [maxAgeError, setMaxAgeError] = useState(false);

  const [sumInsuredError, setSumInsuredError] = useState(false);
  const isAnyFieldBlank = (details) => {
    return details.some((item) => {
      // Check if any field in the object is blank
      return Object.values(item).some((value) => value === "");
    });
  };
  const onBlurError = (e, type) => {
    if (type === "minAge" && (Number(e) < 18 || Number(e) > 60)) {
      setDisabledButton(true);
      toastUpdate(
        "Error",
        "MinAge should be greater than 18 and less than 60",
        true
      );
    } else if (
      type === "maxAge" &&
      (Number(e) < Number(minAge) || Number(e) > 60)
    ) {
      setDisabledButton(true);
      toastUpdate(
        "Error",
        `MaxAge should be greater than ${minAge} and less than 60`,
        true
      );
    } else if (
      type === "sumInsured" &&
      (Number(e) < 20000 || Number(e) > 1000000)
    ) {
      setDisabledButton(true);
      toastUpdate(
        "Error",
        `SumInsured should be greater than 20k and less than 10Lac`,
        true
      );
    } else if (!isAnyFieldBlank(groupDetails)) {
      setDisabledButton(false);
    }
  };
  const handleChange = (e, index, label) => {
    const newValue = e;
    const regex = /^[0-9\b]+$/;
    if (newValue === "" || regex.test(newValue)) {
      setDisabledButton(false);
      setGroupDetails((prev) => {
        const updatedDetails = [...prev];
        updatedDetails[index][label] = newValue;
        return updatedDetails;
      });
    }
  };
  const addNextRow = () => {
    let newIndex = lastIndex + 1;
    setLastIndex(newIndex);
    let newArr = [...groupDetails]; // copying the old datas array
    newArr[newIndex] = {
      minAge: "",
      maxAge: "",
      sumInsured: "",
    };
    setGroupDetails(newArr);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={"Create Sum Insured"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleSumInsuredSubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {Array.apply(null, { length: lastIndex + 1 }).map((e, i) => (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
                style={{ margin: "2% 1% 0px 1%" }}
              >
                <CustomeTextField
                  label="Min Age"
                  required
                  id="name"
                  value={groupDetails?.[i]?.minAge || ""}
                  index={i}
                  setBlur={onBlurError}
                  blurLabel="minAge"
                  error={minAgeError}
                  setError={setMinAgeError}
                  setState={handleChange}
                  type="insurance"
                  textLabel="minAge"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
                style={{ margin: "2% 1% 0px 1%" }}
              >
                <CustomeTextField
                  label="Max Age"
                  required
                  id="days"
                  value={groupDetails?.[i]?.maxAge || ""}
                  setState={handleChange}
                  type="insurance"
                  textLabel="maxAge"
                  setBlur={onBlurError}
                  blurLabel="maxAge"
                  error={maxAgeError}
                  setError={setMaxAgeError}
                  index={i}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
                style={{ margin: "2% 1% 0px 1%" }}
              >
                <CustomeTextField
                  label="Sum Insured"
                  id="sum"
                  value={groupDetails?.[i]?.sumInsured}
                  setState={handleChange}
                  type="insurance"
                  textLabel="sumInsured"
                  required
                  index={i}
                  setBlur={onBlurError}
                  blurLabel="sumInsured"
                  error={sumInsuredError}
                  setError={setSumInsuredError}
                />
              </Grid>
              <IconButton
                aria-label="Delete Disbursal"
                onClick={() => {
                  addNextRow();
                }}
                style={{ padding: "0px", marginTop: "2%" }}
              >
                {lastIndex === i && (
                  <AddIcon
                    style={{
                      color: "green",
                      cursor: "pointer",
                    }}
                  />
                )}
              </IconButton>
            </>
          ))}
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default SumInsuredCreate;
